import { registerVueComponentAndAngularBindings, declareDirective } from '/vodalys/vvuejs'

import WhitelistListing from './WhitelistListing.vue'
import WhitelistListingAddDomain from './WhitelistListingAddDomain.vue'

declareDirective('whitelistListingAddDomain',WhitelistListingAddDomain );
registerVueComponentAndAngularBindings('whitelist:listing', 'whitelistListing', WhitelistListing)
